import { GRID_SIZE } from '../config/constants'
import { loadPlayerPos, clearPlayerPos, snapToGrid } from './persistence'

const isValidSpawn = (pos, tiles, blockedByEntity, gs) => {
  if (!pos) return false
  const col = Math.floor(pos.x / gs)
  const row = Math.floor(pos.y / gs)
  if (!tiles[row]?.[col] || tiles[row][col].solid) return false
  if (blockedByEntity.has(`${col},${row}`)) return false
  const dirs = [[1,0],[-1,0],[0,1],[0,-1],[1,1],[-1,-1],[1,-1],[-1,1]]
  return dirs.some(([dc, dr]) => {
    const nr = row + dr, nc = col + dc
    return nr >= 0 && nr < tiles.length && nc >= 0 && nc < (tiles[0]?.length || 0) && !tiles[nr][nc]?.solid
  })
}

export const computeStartPos = (mapData, dungeonKey, activeSave) => {
  const gs = GRID_SIZE
  const saved = loadPlayerPos(dungeonKey)
  const level0 = mapData.levels ? (mapData.levels[0] ?? mapData) : mapData
  const tiles = level0.tiles

  const blockedByEntity = new Set(
    (level0.entities || [])
      .filter((e) => e.entityType === 'monster' || e.entityType === 'npc' || e.entityType === 'exit')
      .map((e) => `${Math.floor(e.x / gs)},${Math.floor(e.y / gs)}`)
  )

  const rawApiPos = activeSave?.position?.level === 0 ? activeSave.position : null
  const apiPos = rawApiPos ? snapToGrid(rawApiPos.x, rawApiPos.y, gs) : null
  if (isValidSpawn(apiPos, tiles, blockedByEntity, gs)) return apiPos

  if (isValidSpawn(saved, tiles, blockedByEntity, gs)) return saved
  if (saved) clearPlayerPos(dungeonKey)

  for (let r = 1; r < tiles.length - 1; r++) {
    for (let c = 1; c < (tiles[0]?.length || 0) - 1; c++) {
      const pos = { x: c * gs, y: r * gs }
      if (isValidSpawn(pos, tiles, blockedByEntity, gs)) return pos
    }
  }

  // BFS fallback for degenerate maps
  const cols = tiles[0]?.length || 0
  const bfsQueue = [[1, 1]]
  const bfsSeen = new Set(['1,1'])
  while (bfsQueue.length) {
    const [r, c] = bfsQueue.shift()
    if (r >= 0 && r < tiles.length && c >= 0 && c < cols && tiles[r]?.[c] && !tiles[r][c].solid) {
      return { x: c * gs, y: r * gs }
    }
    for (const [dr, dc] of [[0,1],[0,-1],[1,0],[-1,0]]) {
      const key = `${r + dr},${c + dc}`
      if (!bfsSeen.has(key)) {
        bfsSeen.add(key)
        bfsQueue.push([r + dr, c + dc])
      }
    }
  }
  return { x: gs, y: gs }
}
